<label
  class="relative inline-flex h-8 w-14 rounded-full transition-colors duration-300 ease-in-out"
  [ngClass]="value() ? 'bg-orange-500' : 'bg-gray-200'"
>
  <input
    class="peer absolute inset-0 m-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
    [checked]="value()"
    [attr.aria-label]="ariaLabel()"
    (change)="onCheckboxChange($event)"
    type="checkbox"
  />
  <span
    class="pointer-events-none absolute top-1 bottom-1 left-1 w-6 rounded-full transition-colors transition-transform duration-300 ease-in-out"
    [ngClass]="value() ? 'translate-x-full bg-white' : 'bg-black'"
    aria-hidden="true"
  ></span>
</label>
